import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { IconComponent } from '@sarasanalytics-com/design-system';
import { catchError, of, switchMap } from 'rxjs';
import { RequestParam } from 'src/app/interfaces/requestParam';
import {
  FirebaseMode,
  IAppParams,
  Products,
} from 'src/app/interfaces/state-interface';
import { AppService } from 'src/app/services/app.service';
import { DataService } from 'src/app/services/data/data.service';
import { QueryParamService } from 'src/app/services/queryParam/query-param.service';
import { SignupService } from 'src/app/services/signup/signup.service';
import {
  IMessageView,
  MessageViewComponent,
  MessageViewEvent,
} from 'src/app/shared/components/message-view/message-view.component';

@Component({
  selector: 'app-custom-firebase',
  standalone: true,
  imports: [CommonModule, MessageViewComponent, IconComponent],
  templateUrl: './custom-firebase.component.html',
  styleUrl: './custom-firebase.component.scss',
})
export class CustomFirebaseComponent {
  private qpService: QueryParamService = inject(QueryParamService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private appService: AppService = inject(AppService);
  private dataService: DataService = inject(DataService);
  private signupService: SignupService = inject(SignupService);

  private afAuth = inject(AngularFireAuth);
  private router = inject(Router);
  queryParam: IAppParams = {};
  userId: string;

  messageView: IMessageView | null;
  product: Products;
  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      const qp = this.route.snapshot.queryParamMap;
      this.product = (
        qp.get('productName') ||
        qp.get('productType') ||
        Products.SARAS
      ).toUpperCase() as Products;

      const mode: string = qp.get('mode') || '';
      this.queryParam.mode = mode as FirebaseMode;
      this.queryParam.code = qp.get('oobCode') || '';
      this.queryParam.continueUrl = qp.get('continueUrl') || '';
      this.queryParam.email = this.appService.sanitizeEmailFromParams(
        qp.get('email') || this.getParamFromUrl('email')
      );
      this.queryParam.userId = qp.get('id') || this.getParamFromUrl('id') || '';
      if (this.queryParam.mode) {
        switch (this.queryParam.mode) {
          case FirebaseMode.verifyEmail:
            if (this.queryParam.continueUrl) {
              const url = new URL(this.queryParam.continueUrl);
              const usp = new URLSearchParams();
              window.open(this.queryParam.continueUrl, '_self');
            }
            break;
          case FirebaseMode.recoverEmail:
            break;
          case FirebaseMode.unrollMFA:
            this.router.navigate(['unenroll-mfa'], {
              queryParams: {
                productType: this.product,
                email: this.queryParam.email,
                oobCode: this.queryParam.code,
              },
            });
            break;
          default:
            break;
        }
      }
    });
  }
  getParamFromUrl(param: string = 'id') {
    try {
      if (this.queryParam.continueUrl) {
        const url = new URL(this.queryParam.continueUrl);
        return url.searchParams.get(param) || '';
      }
      return '';
    } catch (e) {
      console.log(e);
      return '';
    }
  }

  onMessageViewEvent(event: MessageViewEvent) {
    switch (event) {
      case MessageViewEvent.RESEND:
        // this.resendEmailVerification();
        break;
      case MessageViewEvent.BUTTON:
        break;
      default:
        break;
    }
  }
}
